<template>
  <div v-if="orders.length">
    <strong class="text-danger">Blocat pentru comenzile refuzate:</strong>
    <b-list-group>
      <b-list-group-item class="d-flex px-2 py-1" :to="{ name: 'OperatorOrderView', params: { id: item.order.id } }" v-for="item in orders" :key="'punish-' + item.order.id">
        <span class="mr-2"> #{{ item.order.id }}: </span>
        <div v-if="item.order.places.length && item.order.places[0].name">
          <span v-if="item.order.places[0].name.length >= 25">
            {{ item.order.places[0].name.substring(0,25)+".." }}
          </span>
          <span v-else>{{ item.order.places[0].name }}</span>
        </div>
        <small class="ml-auto text-muted text-nowrap">{{ formatRejectedAt(item.rejected_at) }}</small>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'DriverPunishOrders',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      orders: []
    }
  },
  watch: {
    'user.id': {
      immediate: true,
      handler () {
        this.load()
      }
    }
  },
  methods: {
    isBanned () {
      // ban_until is a raw UTC 'YYYY-MM-DD HH:mm:ss' string from the backend
      return !!this.user.ban_until && this.$day.utc(this.user.ban_until).isAfter(this.$day())
    },
    load () {
      this.orders = []
      if (this.user.id && this.isBanned() && this.user.ban_reason === 'Ignorarea comenzilor') {
        this.$axios.get(config.baseApiUrl + '/api/users/' + this.user.id + '/punish-orders')
          .then(response => {
            this.orders = response.data.orders
          })
      }
    },
    formatRejectedAt (value) {
      return this.$day.utc(value).local().format('DD.MM HH:mm')
    }
  }
}
</script>

<style scoped>

</style>
